<template>
<div v-show="isModalVisible">
  <div class="modal-mask" @click="closeModal">
        <div class="modal-container" @click.stop>
        <!-- Modal Header -->
        <div class="modal-header">
          <slot name="header"></slot>
          <button type="button" class="close" data-dismiss="modal" @click="closeModal">&times;</button>
        </div>
        <!-- Modal body -->
        <div class="modal-body">
          <slot name="body"></slot>
        </div>
        <!-- Modal footer -->
        <div class="modal-footer">
          <slot name="footer"></slot>
        </div>
        </div>
  </div>
</div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
export default {
  props: [
    'isModalVisible',
    ],
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
  },
}
</script>

<style scoped>
.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    transition: opacity .3s ease;
}
.modal-container {
    width: 600px;
    margin: 40px auto 0;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
}
.modal-body {
    margin: 0px;
    padding: 0px 10px;
}
.modal-header .sub-heading {
  background-color: #FFF;
  color: #555;
}
.modal-header {
  padding: 5px;
  border: 0px;
  text-align: center;
}
.publish-header {
  text-align: center;
  color: #555;
  padding: 5px;
}
.modal-header .close {
  margin: -1.5rem -2rem -1rem auto;
}
.modal-footer {
  border-top: none;
}
.export-details, .percentage-text {
  font-size: 14px;
  font-weight: bold;
}
.percentage-text {
  margin-top: 15px;
  text-align: right;
}
.batch-box {
  width: 100%;
  border: 1px solid #A9A9A9;
  height: 14px;
  border-radius: 10px;
  background-color: #EEE;
}
.batch-loading {
  background-color: #00ACEE;
  border-radius: 10px;
  height: 12px;
}
.download-link {
  margin-top: 25px;
  color: #00ACEE;
  font-size: 14px;
  padding-bottom: 2px;
  text-decoration: underline;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/reports/report_loading_modal.vue